/**
 * Snapshot of the rep's pacing for the day. Source of truth for the top-strip
 * `PacingStrip` and the right-rail compact pacing header.
 *
 * Discriminated by `status` so the UI can branch between skeleton / loaded /
 * error without a separate "isLoading" boolean.
 */
export type DialPacingSnapshot =
	| { status: 'skeleton' }
	| { status: 'error'; message: string }
	| {
			status: 'loaded';
			dialsToday: number;
			/** Optional — null when the user has no goal configured. */
			dialGoal: number | null;
			connectsToday: number;
			demosBookedToday: number;
			pacePerHour: number;
	  };

export function isLoadedSnapshot(
	snapshot: DialPacingSnapshot
): snapshot is Extract<DialPacingSnapshot, { status: 'loaded' }> {
	return snapshot.status === 'loaded';
}
